// src/router/ticket.router.ts
import type { RouteRecordRaw } from 'vue-router'

export const ticketRoutes: RouteRecordRaw[] = [
  {
    path: 'ticket',
    name: 'ticket',
    component: () => import('@/views/page/ticket/TicketData.vue'),
    meta: { title: 'Ticket' },
  },
  {
    path: 'ticket/trash',
    name: 'ticket-trash',
    component: () => import('@/views/page/ticket/TicketData.vue'),
    meta: { title: 'Ticket Trash' },
  },
  {
    path: 'ticket/create',
    name: 'ticket-create',
    component: () => import('@/views/page/ticket/TicketInput.vue'),
    meta: { title: 'Create Ticket' },
  },
  {
    path: 'ticket/:id/edit',
    name: 'ticket-edit',
    component: () => import('@/views/page/ticket/TicketInput.vue'),
    meta: { title: 'Edit Ticket' },
  },
  {
    path: 'ticket/:id/print',
    name: 'ticket-print',
    component: () => import('@/views/page/ticket/TicketPrint.vue'),
    meta: { title: 'Print Ticket' },
  },
]
